(function () {
	'use strict';

	angular.module('dcApp').directive('valueColumnFilter', [
		'$parse',
		function ($parse) {
			var controller = [
				'$scope',
				function ($scope) {
					var vm = this;

					$scope.getMatchingColumns = function (columns, type) {
						var cols = [];
						for (var c in columns) {
							if (columns[c].type == type) {
								cols.push(columns[c]);
							}
						}
						return cols;
					};

					$scope.save = function () {
						vm.widgetData.valueColumn = $scope.valueColumn;
						vm.widgetData.updateaction_l2();
						closeModal();
					};

					$scope.cancel = function () {
						closeModal();
					};

					function closeModal() {
						$(vm.element).modal('hide');
						vm.widgetData.showValueColumnFilter = false;
					}
				},
			];

			return {
				restrict: 'E',

				scope: {
					widgetData: '=',
					saveAction: '&',
				},
				controller: controller,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl:
					'./src/components/directives/dataOperationTools/valueColumnFilter/valueColumnFilter.html',
				transclude: true,
				replace: true,
				link: function postLink(scope, element, attrs) {
					$(element).modal({
						show: false,
						keyboard: attrs.keyboard,
						backdrop: attrs.backdrop,
					});
					$(element).on('hidden.bs.modal', function () {
						scope.$apply(function () {
							scope.vm.widgetData.showValueColumnFilter = false;
						});
					});
					scope.$watch(
						function () {
							return scope.vm.widgetData.showValueColumnFilter;
						},
						function (value) {
							scope.vm.element = element;
							if (value == true) {
								scope.valueColumn = { column: scope.vm.widgetData.valueColumn };
								scope.columns = scope.vm.widgetData.columns;
								scope.selectedRule = scope.vm.widgetData.selectedRule;

								$(element).modal('show');
							} else {
								$(element).modal('hide');
							}
						}
					);
				},
			};
		},
	]);
})();
